import { render, staticRenderFns } from "./CollectionInformationModal.vue?vue&type=template&id=c9f565f2&scoped=true&"
import script from "./CollectionInformationModal.vue?vue&type=script&lang=js&"
export * from "./CollectionInformationModal.vue?vue&type=script&lang=js&"
import style0 from "./CollectionInformationModal.vue?vue&type=style&index=0&id=c9f565f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9f565f2",
  null
  
)

export default component.exports